import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import { notifyPromise, notifySuccess, setLocalStorageItem } from "../../../Utils/Helper";
import { loginFailure, loginSuccess } from "../../Action/auth/loginAction";
import { LOGIN } from "../../Action/actionTypes";

function* loginRequest(action) {
  try {
    console.log("action?.payload?.payload",action?.payload?.payload)
    const { data } = yield notifyPromise(
      API.post("/login", action?.payload?.payload)
    );
    if (action?.payload?.callback) {
      yield call(action.payload.callback, data);
    }
    if (data?.meta?.code === 200) {
      const groupName = action?.payload?.payload?.groupName;
      const isCorporate = groupName === "MoneyplantFX";
      const statusRaw = data?.data?.status;
      const status = statusRaw === undefined || statusRaw === null ? undefined : Number(statusRaw);

      // Corporate users must only proceed when status === 1.
      // This prevents corporate users from entering email/KYC verification flows.
      // If backend doesn't send a status field, do not block login here.
      if (isCorporate && status !== undefined && status !== 1) {
        yield put(loginFailure());
        return;
      }
      yield put(loginSuccess(data?.data));
      yield call(setLocalStorageItem, "userData", JSON.stringify(data?.data));
      yield call(setLocalStorageItem, "token", data?.meta?.token);

    } else {
      yield put(loginFailure());
    }
  } catch (error) {
    yield put(loginFailure());
  }
}

export function* watchLoginAPI() {
  yield takeEvery(LOGIN, loginRequest);
}

export default function* rootSaga() {
  yield all([watchLoginAPI()]);
}
